// Images a phone keyboard inserts (one from Gboard's clipboard, a GIF, a sticker) arrive from
// the app's WebView (android/.../BusyBeeWebView.java) as a 'bb-keyboard-image' event. Each is
// pasted where the person is writing, as a pasted file, so every editor that takes a pasted
// image (a task's description, documents, a bot chat) takes it the same way.
const EXT = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/gif': 'gif', 'image/webp': 'webp', 'image/heic': 'heic' };

export const fileFromKeyboard = ({ type, data }) => {
  const bytes = Uint8Array.from(atob(data), (c) => c.charCodeAt(0));
  const mime = /^image\/[\w.+-]+$/.test(type || '') ? type : 'image/png';
  return new File([bytes], `image.${EXT[mime] || 'png'}`, { type: mime });
};

export function listenForKeyboardImages() {
  const onImage = (e) => {
    const target = document.activeElement;
    if (!target || target === document.body || !e.detail?.data) return;
    const clipboardData = new DataTransfer();
    clipboardData.items.add(fileFromKeyboard(e.detail));
    target.dispatchEvent(new ClipboardEvent('paste', { clipboardData, bubbles: true, cancelable: true }));
  };
  window.addEventListener('bb-keyboard-image', onImage);
  return () => window.removeEventListener('bb-keyboard-image', onImage);
}
